module.exports = __webpack_public_path__ + "static/media/hybrid.353e568a.svg";